import { render } from "./maintenanceInfo.vue?vue&type=template&id=0a5c2700&scoped=true"
import script from "./maintenanceInfo.vue?vue&type=script&lang=js"
export * from "./maintenanceInfo.vue?vue&type=script&lang=js"

import "./maintenanceInfo.vue?vue&type=style&index=0&id=0a5c2700&scoped=true&lang=css"

import exportComponent from "/home/tyamada/ckan-ext-dev/yamanashi-dataplatform-admin-system-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a5c2700"]])

export default __exports__